<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder mb-0">{{ $t('animal.Animal_info') }}</h5>
    <p class="mb-0 text-sm">{{ $t('animal.Mandatory_informations') }} *</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.UBN') }}</label>
            <input :value="selectedUbnText" type="text" class="form-control form-control-default" disabled>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('animal.Tag_number') }} </label>
            <input v-model="localFormData.tagNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Tag_number')">
          </div>
        </div>        
        <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Country_of_birth') }} *</label>
              <select id="countryOfBirthId" v-model="localFormData.countryOfBirthId" class="form-control form-control-default">
                <option value="">{{ $t('animal.Select_country_of_birth') }}</option>         
                <option v-for="item in countryCodes" :key="item.id" :value="item.id">                  
                    {{ item.name }}
                </option>
              </select>
              <span v-if="v$.countryOfBirthId.$error" class="text-sm text-danger">
                  {{ v$.countryOfBirthId.$errors[0].$message }}
              </span>
            </div>
          </div>  
      </div>
      <div class="row mt-4">        
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('animal.Animal_number') }}</label>
            <input v-model="localFormData.animalNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Animal_number')">            
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('animal.Studbook_number') }} *</label>
            <input v-model.lazy.trim="localFormData.studbookNumber" @blur="v$.studbookNumber.$touch()" type="text" class="form-control form-control-default" :placeholder="$t('animal.Studbook_number')">
            <span v-if="v$.studbookNumber.$error" class="text-sm text-danger">
              {{ v$.studbookNumber.$errors[0]?.$message }}
            </span>
          </div>
        </div>
        <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Birth_date') }} *</label>
              <input v-model="localFormData.birthDate" type="date" class="form-control form-control-default" :placeholder="$t('animal.Birth_date')">
              <span v-if="v$.birthDate.$error" class="text-sm text-danger">
                  {{ v$.birthDate.$errors[0].$message }}
              </span>
            </div>
          </div>
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Gender') }} *</label>  
            <select id="genderId" v-model="localFormData.genderId" class="form-control form-control-default">
                <option value="">{{ $t('animal.Select_gender') }}</option>         
                <option v-for="item in animalGenders" :key="item.id" :value="item.id">                  
                    {{ item.name }}
                </option>
            </select>
            <span v-if="v$.genderId.$error" class="text-sm text-danger">
                {{ v$.genderId.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Breed') }} *</label>  
            <select id="breedId" v-model="localFormData.breedId" class="form-control form-control-default">
                <option value="">{{ $t('animal.Select_breed') }}</option>
                <option v-for="item in breeds" :key="item.id" :value="item.id">
                    {{ item.name }}
                </option>
            </select>
            <span v-if="v$.breedId.$error" class="text-sm text-danger">
                {{ v$.breedId.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('animal.Casterated') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="localFormData.casterated" id="casterated" name="casterated" />
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">          
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('animal.Name') }}</label>
                <input v-model="localFormData.name" type="text" class="form-control form-control-default" :placeholder="$t('animal.Name')">                
              </div>
          </div>  
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Colour') }}</label>  
              <select id="colorId" v-model="localFormData.colorId" class="form-control form-control-default">
                  <option value="">{{ $t('animal.Select_colour') }}</option>         
                  <option v-for="item in animalColours" :key="item.id" :value="item.id">                  
                      {{ item.name }}
                  </option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Inbreed_Factor') }}</label>
              <input v-model="localFormData.inbreedFactor" type="text" class="form-control form-control-default" :placeholder="$t('animal.Inbreed_Factor')">
              <span v-if="v$.inbreedFactor.$error" class="text-sm text-danger">
                {{ v$.inbreedFactor.$errors[0].$message }}
              </span>
            </div>
          </div>      
      </div>
      <div class="row mt-4">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Genotype') }}</label>  
              <select id="genoTypeId" v-model="localFormData.genoTypeId" class="form-control form-control-default">
                  <option value="">{{ $t('animal.Select_genotype') }}</option>
                  <option v-for="item in animalGenoTypes" :key="item.id" :value="item.id">
                      {{ item.name }}
                  </option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Genotype2') }}</label>  
              <select id="genoTypeId2" v-model="localFormData.genoTypeId2" class="form-control form-control-default">
                  <option value="">{{ $t('animal.Select_genotype2') }}</option>
                  <option v-for="item in animalGenoTypes2" :key="item.id" :value="item.id">
                      {{ item.name }}
                  </option>
              </select>
            </div>
          </div>
      </div>      
      <div class="button-row d-flex mt-4"> 
        <input v-model="localFormData.ubnId" type="hidden">       
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto mb-0 js-btn-next" type="button" :disabled="v$.$pending || v$.$invalid" @click="validateAndNextStep">{{ $t('common.Next') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { computed, reactive, watch} from 'vue'
import { useI18n } from 'vue-i18n'
import axios from 'axios'

export default {
  name: "AnimalInfo",
  props: {
    formData: Object,
    nextStep: Function,
    roles: Array,
    inspectors: Array,        
    breeds: Array,
    animalGenoTypes: Array,
    animalGenoTypes2: Array,
    countryCodes: Array,
    animalGenders: Array,
    animalColours: Array,
    emitter: Object
  }, 
  setup(props, { emit }) {
    
    const { t } = useI18n()

    const localFormData = reactive({ ...props.formData, 
      userStartDate: props.formData.userStartDate ?? new Date().toISOString().split('T')[0]})

    const integerOnly = helpers.withMessage(
      t('common.Integer_only'),
      value => {
        if (value === '' || value === null || value === undefined) return true;
        return /^[0-9]+$/.test(value);
      }
    )

    // ---- Async studbook validator (with caching + abort) ----
    const existsCache = new Map();
    let inFlightCtrl = null;

    const checkStudbookExists = async (value) => {
      const key = String(value || "").trim().toUpperCase();

      if (!key) return false;
      if (!localFormData.associationId) return false; // guard until association is chosen

      if (existsCache.has(key)) return existsCache.get(key);

      if (inFlightCtrl) inFlightCtrl.abort();
      inFlightCtrl = new AbortController();

      try {
        const { data } = await axios.get("animal/studbookexists", {
          params: {
            associationId: localFormData.associationId,
            studbookNumber: key,
          },
          signal: inFlightCtrl.signal,
        });

        const ok = !!data?.exists;
        existsCache.set(key, ok);
        return ok;
      } catch (err) {
        if (axios.isCancel?.(err)) {
          // typing fast; let validation re-run on next keystroke/blur
          return false;
        }
        console.error("Studbook validation failed:", err);
        return false;
      }
    };

    const rules = computed(() => ({
        studbookNumber: {
          required: helpers.withMessage(t('common.Required'), required),
          format: helpers.withMessage(
            t('common.Only_letters_numbers_and_hyphens_are_allowed'),
            (v) => /^[A-Za-z0-9-]+$/.test(String(v || '').trim())
          ),
          unique: helpers.withMessage(
            t('common.Studbook_number_already_exists'),
            helpers.withAsync(async (v) => {
              const exists = await checkStudbookExists(v)
              return !exists
            })
          )
        },
        breedId: {
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('animal.Select_breed'), v => v !== '')
        },
        countryOfBirthId: {
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('animal.Select_country_of_birth'), v => v !== '')
        },
        genderId: {
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('animal.Select_gender'), v => v !== '')
        },
        birthDate: { required: helpers.withMessage(t('common.Required'), required) },
        inbreedFactor: { integerOnly }
      }    
    ));

    
    const v$ = useVuelidate(rules, localFormData, { $autoDirty: true })
    
    watch(
      () => props.formData.associationId,
      (val) => { localFormData.associationId = val },
      { immediate: true }
    )

    watch(
      () => props.formData.ubn,
      (newVal) => {
        localFormData.ubn = newVal;
      }
    );

    watch(
      () => props.formData.ubnId,
      (newVal) => {
        localFormData.ubnId = newVal;
      },
      { immediate: true }
    );

    watch(localFormData, () => {
      emit('update:formData', localFormData)
    }, { deep: true })

    const validateAndNextStep = async () => {
      const ok = await v$.value.$validate();
      if (!ok) return;

      // normalize before proceed (reactive object, no .value!)
      if (localFormData.studbookNumber) {
        localFormData.studbookNumber = localFormData.studbookNumber
          .trim()
          .toUpperCase();
      }

      props.nextStep && props.nextStep();
    };   

    return {
      localFormData,      
      v$,
      validateAndNextStep
    }
  },
  computed: {
    selectedUbnText() {
      return this.localFormData.ubn || '';
    }
  },
  components: {      
    MaterialSwitch,
  },
  methods: {            
  }
}
</script>